import Helper from '@ember/component/helper';
export default class SetIncludes extends Helper {
  compute([set, value]) {
    return set.has(value);
  }
}